const subscription = document.querySelector('.subscription')
let subscriptionCloseBtn
if (subscription) {
    subscriptionCloseBtn = subscription.querySelector('.subscription__wrapper__close-btn').querySelector('svg')
}
const subscriptionWrapper = document.querySelector('.subscription__wrapper')
let bodyScrollHeight = document.querySelector('body').scrollHeight

const subscriptionHandler = function() {
    bodyScrollHeight = document.querySelector('body').scrollHeight
    if (bodyScrollHeight / 2 < window.pageYOffset + document.body.clientHeight) {
        subscription.classList.add('active')
        subscriptionWrapper.classList.add('active')
    }
}

if (subscription) {
    window.addEventListener('scroll', subscriptionHandler)
    subscriptionCloseBtn.addEventListener('click', () => {
        subscriptionClose()
    })
}

function subscriptionClose() {
    subscription.classList.remove('active')
    subscriptionWrapper.classList.remove('active')
    window.removeEventListener('scroll', subscriptionHandler)
}